import { render, staticRenderFns } from "./ShopOrderSingle.vue?vue&type=template&id=1866e185&scoped=true&"
import script from "./ShopOrderSingle.vue?vue&type=script&lang=js&"
export * from "./ShopOrderSingle.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrderSingle.vue?vue&type=style&index=0&id=1866e185&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1866e185",
  null
  
)

export default component.exports